import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { EnvironmentThemeProvider } from '@codex-brightworld/themes';

import SingleContainer from '../SingleContainer/SingleContainer.jsx';

const StyledWrapper = styled.div`
  max-width: 420px;
  padding: 0 0 10px 10px;
  background: ${(props) => props.theme.colors.neutral.grey[0]};

  @media ${(props) => props.theme.breakpoints.mobile} {
    width: auto;
    padding: 0 5px;
  }
`;

const StyledContainer = styled.div`
  padding: 10px;
  background: ${(props) => props.theme.colors.neutral.grey[0]};

  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 10px 5px;
  }
`;

const StyledBorder = styled.div`
  border-radius: 10px;
  border: 1px solid ${(props) => props.theme.colors.neutral.grey[2]};
  padding: 0 20px;
  background: ${(props) => props.theme.colors.neutral.white};
  
  @media ${(props) => props.theme.breakpoints.mobile} {
    padding: 0 10px;
  }
`;

const Container = ({
  installation,
  recycling,
  installationInProgress,
  recyclingInProgress,
  recyclingFailed,
  installationFailed,
  failedToUpdateBasket,
  pleaseTryAgain
}) => {

  const [isInstallPopoverDisplayed, setInstallPopoverDisplayed] = useState(false);
  const [isRecyclePopoverDisplayed, setRecyclePopoverDisplayed] = useState(false);

  const handlePopover1Display = (isDisplayed) => {
    setInstallPopoverDisplayed(isDisplayed);
    setRecyclePopoverDisplayed(false);
  };

  const handlePopover2Display = (isDisplayed) => {
    setInstallPopoverDisplayed(false);
    setRecyclePopoverDisplayed(isDisplayed);
  };

  let installationContainer = null;
  if (installation && installation.display) {
    installationContainer = (
      <SingleContainer
        {...installation}
        hasBorder={recycling.display}
        failedToUpdateBasket={failedToUpdateBasket}
        pleaseTryAgain={pleaseTryAgain}
        isInProgress={installationInProgress}
        displayError={installationFailed}
        isPopoverDisplayed={isInstallPopoverDisplayed}
        handlePopoverDisplay={handlePopover1Display}
      />
    );
  }

  let recyclingContainer = null;
  if (recycling && recycling.display) {
    recyclingContainer = (
      <SingleContainer
        {...recycling}
        failedToUpdateBasket={failedToUpdateBasket}
        pleaseTryAgain={pleaseTryAgain}
        isInProgress={recyclingInProgress}
        displayError={recyclingFailed}
        isPopoverDisplayed={isRecyclePopoverDisplayed}
        handlePopoverDisplay={handlePopover2Display}
      />
    );
  }

  return (
    <EnvironmentThemeProvider>
      <div>
        <StyledWrapper>
          <StyledContainer>
            <StyledBorder>
              {installationContainer}
              {recyclingContainer}
            </StyledBorder>
          </StyledContainer>
        </StyledWrapper>
      </div>
    </EnvironmentThemeProvider>
  );
};

Container.propTypes = {
  installation: PropTypes.shape({
    display: PropTypes.bool.isRequired,
    productId: PropTypes.number.isRequired,
    typeText: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    productPrice: PropTypes.number.isRequired,
    productCurrency: PropTypes.string,
    moreInfoText: PropTypes.string.isRequired,
    addOnClick: PropTypes.func.isRequired,
    moreDetails: PropTypes.shape({
      isExpanded: PropTypes.bool.isRequired,
      html: PropTypes.string.isRequired
    }).isRequired
  }),
  recycling: PropTypes.shape({
    display: PropTypes.bool.isRequired,
    productId: PropTypes.number.isRequired,
    typeText: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    productPrice: PropTypes.number.isRequired,
    productCurrency: PropTypes.string,
    moreInfoText: PropTypes.string.isRequired,
    addOnClick: PropTypes.func.isRequired,
    moreDetails: PropTypes.shape({
      isExpanded: PropTypes.bool.isRequired,
      html: PropTypes.string.isRequired
    }).isRequired
  }),
  installationInProgress: PropTypes.bool,
  recyclingInProgress: PropTypes.bool,
  recyclingFailed: PropTypes.bool,
  installationFailed: PropTypes.bool,
  failedToUpdateBasket: PropTypes.string.isRequired,
  pleaseTryAgain: PropTypes.string.isRequired
};

Container.defaultProps = {
  installation: null,
  recycling: null,
  installationInProgress: false,
  recyclingInProgress: false,
  recyclingFailed: false,
  installationFailed: false
};

export default Container;
